import { render, staticRenderFns } from "./PlaylistedEntity.vue?vue&type=template&id=487c49b1&scoped=true&"
import script from "./PlaylistedEntity.vue?vue&type=script&lang=js&"
export * from "./PlaylistedEntity.vue?vue&type=script&lang=js&"
import style0 from "./PlaylistedEntity.vue?vue&type=style&index=0&id=487c49b1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487c49b1",
  null
  
)

export default component.exports